module.exports = __webpack_public_path__ + "img/vertical_6_4_9016.309d45c4.png";